import { Quote as QuoteIcon, Info } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

export const PlaceholderNotice = () => (
  <div className="flex items-start gap-3 rounded-2xl border border-amber-200 bg-amber-50 px-5 py-4 text-sm text-amber-900" data-testid="reviews-placeholder-notice">
    <Info className="mt-0.5 h-4 w-4 shrink-0" />
    <p>These are placeholders. Genuine customer reviews will be added here once they're received – we don't publish invented names, reviews or ratings.</p>
  </div>
);

export const ReviewCard = ({ n, category, delay = 0 }) => (
  <Reveal delay={delay} className="h-full">
    <figure className="flex h-full flex-col rounded-[1.5rem] border border-dashed border-slate-300 bg-white p-8" data-testid={`review-placeholder-${n}`}>
      <QuoteIcon className="h-8 w-8 text-[var(--green)]" />
      <span className="mt-6 inline-flex w-fit rounded-full bg-[var(--grey)] px-3 py-1 text-xs font-semibold uppercase tracking-wider text-slate-600">Placeholder review</span>
      <blockquote className="mt-4 flex-1 font-display text-xl leading-snug text-slate-500">
        A genuine customer testimonial about {category.toLowerCase()} will appear here.
      </blockquote>
      <figcaption className="mt-8 border-t border-slate-200 pt-5 text-sm">
        <span className="block font-semibold text-slate-600">[Customer name]</span>
        <span className="text-slate-500">[Area, Oxfordshire] · {category}</span>
      </figcaption>
    </figure>
  </Reveal>
);
